import _classCallCheck from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import React, { PureComponent } from "react";
//Material imports
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import FormControl from "@material-ui/core/FormControl";
import CircularProgress from "@material-ui/core/CircularProgress"; //Limitless imports

import { withi18n } from "../../hocs/i18n";

var SubmitButton = /*#__PURE__*/function (_PureComponent) {
  _inherits(SubmitButton, _PureComponent);

  var _super = _createSuper(SubmitButton);

  function SubmitButton() {
    _classCallCheck(this, SubmitButton);

    return _super.apply(this, arguments);
  }

  _createClass(SubmitButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          classes = _this$props.classes,
          disabled = _this$props.disabled,
          handleSubmit = _this$props.handleSubmit,
          title = _this$props.title,
          loading = _this$props.loading,
          t = _this$props.t,
          type = _this$props.type,
          component = _this$props.component,
          containerEnabled = _this$props.containerEnabled,
          id = _this$props.id,
          staticButton = _this$props.staticButton;
      var submitButtonEnabledStyle = loading || !disabled ? {
        width: "250px"
      } : {};
      submitButtonEnabledStyle = staticButton ? {
        width: "unset"
      } : submitButtonEnabledStyle;
      return /*#__PURE__*/React.createElement(FormControl, {
        className: containerEnabled ? classes.container : ""
      }, /*#__PURE__*/React.createElement(Button, {
        variant: "contained",
        color: "primary",
        className: classes.submitButton,
        onClick: handleSubmit,
        disabled: disabled,
        style: submitButtonEnabledStyle,
        component: component ? component : "div",
        type: type,
        id: id,
        classes: {
          containedPrimary: classes.buttonRoot
        }
      }, t(title)), loading && /*#__PURE__*/React.createElement(CircularProgress, {
        size: 24,
        className: classes.buttonProgress
      }));
    }
  }]);

  return SubmitButton;
}(PureComponent);

var styles = function styles(theme) {
  var buttonStyles = {
    container: {
      margin: "10px 25px 10px 25px"
    },
    submitButton: {
      margin: theme.spacing(1),
      fontSize: theme.typography.fontSize,
      transition: ".25s all",
      display: "flex",
      alignSelf: "center",
      width: 205
    },
    rightIcon: {
      marginLeft: theme.spacing(1),
      width: "17px"
    },
    buttonProgress: {
      position: "absolute",
      top: "50%",
      left: "50%",
      marginTop: -12,
      marginLeft: -12
    }
  };

  if (theme.palette.buttons) {
    buttonStyles.buttonRoot = {
      color: theme.palette.buttons.submit.textColor,
      backgroundColor: theme.palette.buttons.submit.backgroundColor,
      "&:hover": {
        color: theme.palette.buttons.submit.textColor,
        backgroundColor: theme.palette.buttons.submit.hoverBackgroundColor
      }
    };
  }

  return buttonStyles;
};

export default withStyles(styles)(withi18n(SubmitButton));
SubmitButton.defaultProps = {
  containerEnabled: true,
  staticButton: false
};